import React from 'react';

import { UpsellCategory } from '../utils/product-detail.types';

import classes from './RelatedCategories.scss';

type Props = {
    categories?: UpsellCategory[];
};

export const RelatedCategories: React.FC<Props> = ({ categories }) => {
    if (!categories) return null;

    const filteredCategories = categories.filter((category) => {
        const { url_path = '' } = category;

        return url_path !== null;
    });

    const limitedCategories = filteredCategories.slice(0, 3);

    if (limitedCategories.length < 3) return null;

    return (
        <div className={classes.relatedCategories}>
            <h2>Continue Shopping</h2>
            <div className={classes.categories}>
                {limitedCategories.map((category, i) => (
                    <a
                        key={i}
                        href={category?.url_path || ''}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.category}
                    >
                        {category.breadcrumb_label !== null ? category.breadcrumb_label : category.name}
                    </a>
                ))}
            </div>
        </div>
    );
};
